import React, { Component } from 'react';
import { Link,withRouter} from 'react-router-dom';
import {permissionCheck} from  './../../core/Permission';

import {routes} from '../../Routes';
 
class MainSideBar extends Component {
    routerPermissionCheck(routes){ 
        let checkSum=false;
        routes && routes.map((sroute) =>{ 
            if(sroute.show && permissionCheck(sroute.path.replace('/',''),'Menu') && checkSum===false){
                checkSum=true;
            }  
        }
        ); 
        return checkSum;
    }
    render() { 
        const path=this.props.location.pathname.split('-action')[0];  
        return   <aside id="sidebar_main">
            <div className="sidebar_main_header">
                <div className="sidebar_logo" style={{height:'auto',textAlign:'center',marginLeft:'-38px'}}>
                    <Link to='/' ><img src={`${window.publicUrl}/assets/img/avatars/logo.png`} style={{height:'100px',width:'100px'}}/></Link>
                </div>
            </div>
            <div className="menu_section">
                <ul>
                    {
                        routes && routes.map((route,k) => 
                            route.show && this.routerPermissionCheck(route.routes) &&
                            <li key={k} title={route.name} className={`submenu_trigger ${path.includes(route.name.toLowerCase())?'current_section':''}`} > 
                                <a href="#"> 
                                    <span className="menu_icon"><i className="material-icons">{ route.icon?route.icon:'dashboard'}</i></span>
                                    <span className="menu_title"> {route.name}</span> 
                                </a>
                                <ul>
                                    {route.routes && route.routes.map((secondLevel,m) => 
                                        secondLevel.show && permissionCheck(secondLevel.path.replace('/',''),'Menu') &&
                                        <li key={m} className={`${path===`${route.path}${secondLevel.path}`?'act_item':''}`}>
                                            { route.show && !this.routerPermissionCheck(secondLevel.routes) &&
                                                <Link  to={`${route.path}${secondLevel.path}`} >{secondLevel.name}</Link>
                                            }
                                            { secondLevel.show && this.routerPermissionCheck(secondLevel.routes) &&
                                             <a href="#">
                                                 <span className="menu_title"> {secondLevel.name}</span> 
                                             </a>
                                            }
                                            {  secondLevel.show && this.routerPermissionCheck(secondLevel.routes) &&
                                            <ul> 
                                                {secondLevel.routes && secondLevel.routes.map((thirdLevel,k) => 
                                                    <li key={k}>
                                                        <Link to={`${route.path}${secondLevel.path}${thirdLevel.path}`} >{thirdLevel.name}</Link>
                                                    </li> 
                                                )}
                                            </ul>
                                            } 
                                        </li>
                                    )}
                                </ul>
                            </li>
                        )
                    } 
                </ul>
            </div>
        </aside>
        ;
    }
}
 
export default withRouter(MainSideBar);


// WEBPACK FOOTER //
// ./src/components/Layout/Sidebar.js